/*
 * Wythout — homepage hero image rotator.
 *
 * Runs only when the hero has 2+ images and no video
 * (.wy-hero__media--rotator, wythout-home-hero.liquid). Crossfades between
 * slides on a timer and wires the two PDP-style half-click zones
 * (left = previous, right = next, directional arrow cursors). A manual click
 * pauses the auto-rotation briefly, then it resumes.
 */
(function () {
  document.querySelectorAll('.wy-hero__media--rotator').forEach(function (media) {
    if (media.dataset.rotatorInit) return;
    media.dataset.rotatorInit = '1';

    var slides = Array.prototype.slice.call(media.querySelectorAll('.wy-hero__slide'));
    if (slides.length < 2) return;

    var interval = parseInt(media.getAttribute('data-interval'), 10) || 5000;
    var resumeDelay = 6000;
    var resumeAt = 0;
    var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function go(n) {
      idx = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    }

    function manual(delta) {
      resumeAt = Date.now() + resumeDelay;
      go(idx + delta);
    }

    var prev = media.querySelector('.wy-hero__nav-half--prev');
    var next = media.querySelector('.wy-hero__nav-half--next');
    if (prev) prev.addEventListener('click', function () { manual(-1); });
    if (next) next.addEventListener('click', function () { manual(1); });

    setInterval(function () {
      if (document.hidden) return;
      if (Date.now() < resumeAt) return;
      go(idx + 1);
    }, interval);
  });
})();
